import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch, useHistory } from 'react-router-dom';
import { useSelector, RootStateOrAny } from "react-redux";
import NotFoundPage from '../Pages/NotFoundPage';
import Timeout from '../components/Timeout'
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from '../Pages/errorHandlers/errorBoundary';
import FallBack from '../Pages/errorHandlers/fallBack';

const Login = lazy(() => import('../Pages/Account/login'));
const Mtoken = lazy(() => import('../Pages/Account/mtoken'));
const Dashboard = lazy(() => import('../Pages/Account/Dashboard'));
const Policy = lazy(() => import('../Pages/Account/policy'));
const Profile = lazy(() => import('../Pages/Account/Profile'));
const Application = lazy(() => import('../Pages/Account/Application'));
const Notification = lazy(() => import('../Pages/Account/Notification'));
const Loancalculator = lazy(() => import('../Pages/Account/Loancalculator'));
const LoanApplication = lazy(() => import('../Pages/loanApplication/loanApplication'));
const ApplicationToken = lazy(() => import('../Pages/loanApplication/ApplicationToken'));
const LoanMessage = lazy(() => import('../Pages/loanApplication/loanMessage'));
const LoanApproval = lazy(() => import('../Pages/loanApplication/loanApproval'));
const SuccessMessage = lazy(() => import('../Pages/loanApplication/successMessagePage'));
const AdminDashboard = lazy(() => import('.././Pages/Dashboard/index'));
const AdminLogin = lazy(() => import('../Pages/AdminPages/AdminLogin'));
const AdminToken = lazy(() => import('../Pages/AdminPages/adminToken'));

const routes = [
  { path: "/", component: Login, exact: true },
  { path: "/dashboard", component: Dashboard, exact: true },
  { path: "/mtoken", component: Mtoken, exact: true },
  { path: "/profile", component: Profile, exact: true },
  { path: "/application", component: Application, exact: true },
  { path: "/notification", component: Notification, exact: true },
  { path: "/loancalculator", component: Loancalculator, exact: true },
  { path: "/loanapplication", component: LoanApplication, exact: true },
  { path: "/applicationToken", component: ApplicationToken, exact: true },
  { path: "/loanMessage", component: LoanMessage, exact: true },
  { path: "/successMessage", component: SuccessMessage, exact: true },
  { path: "/loanApproval", component: LoanApproval, exact: true },
  { path: "/adminLogin", component: AdminLogin, exact: true },
  { path: "/adminToken", component: AdminToken, exact: true },
  { path: "/policy", component: Policy, exact: true },
  { path: "/admin", component: AdminDashboard },
  { component: NotFoundPage },
];

const AppRouter = () => {
  const userToken = useSelector((state: RootStateOrAny) => state?.token?.userToken?.userName);
  const history = useHistory();

  if(!userToken) {
    history?.push('/');
  }

  return (
    <BrowserRouter>
      <Suspense fallback={<FallBack />}>
        <ErrorBoundary>
          <ToastContainer
            position="top-center"
            autoClose={2000}
          />
          <Timeout />
          <div>
            <Switch>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  component={route?.component}
                />
              ))}
            </Switch>
          </div>
        </ErrorBoundary>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRouter;
